import { onMounted, onBeforeUnmount } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderList as _renderList, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7891cd78"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "settlement-table"
};
const _hoisted_2 = {
  class: "table-header"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  class: "table-container"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1,
  class: "expected-header"
};
const _hoisted_8 = {
  key: 0,
  class: "account-name-cell"
};
const _hoisted_9 = {
  class: "account-name-text"
};
const _hoisted_10 = {
  key: 0,
  class: "out-settle"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 0,
  class: "bank-tail-no"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 8,
  class: "status-cell editable-cell"
};
const _hoisted_15 = {
  key: 9,
  class: "reason-cell"
};
const _hoisted_16 = {
  class: "reason-box"
};
const _hoisted_17 = {
  class: "reason-header"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot"
}, null, -1));
const _hoisted_19 = {
  class: "text"
};
const _hoisted_20 = {
  key: 0,
  class: "remark"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "补充说明：", -1));
const _hoisted_22 = {
  key: 1,
  class: "img-header"
};
const _hoisted_23 = {
  class: "img-box"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 0,
  class: "attach"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "pagination-container"
};
const _hoisted_28 = {
  key: 3,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { gpColumns } from '../types';
import { QuestionCircleOutlined, EditOutlined, ArrowRightOutlined, WarningOutlined, PaperClipOutlined, DownOutlined } from '@ant-design/icons-vue';
import CellEditor from './CellEditor.vue';
import IOSBillModal from './IOSBillModal.vue';
import OtherReasonModal from './OtherReasonModal.vue';
import { updateAccountBill } from '@/api/billApi';
import { message } from 'ant-design-vue';
import { computed } from 'vue';
import { OK } from '@/common';
import { useRoute } from 'vue-router';
import { useStore } from '@/store';
import { useSettlementTable, statusMap, reasonMap } from '../hooks/useSettlementTable';
export default /*#__PURE__*/_defineComponent({
  __name: 'GpTable',
  props: {
    loading: {
      type: Boolean
    },
    data: null,
    pagination: null,
    searchParams: null,
    allAccountList: null
  },
  emits: ['pagination-change', 'update-list', 'sort-change', 'selection-change'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      modalVisible,
      otherReasonModalVisible,
      currentRecord,
      editFieldModalVisible,
      editingField,
      editingValue,
      editingMonth,
      editFieldTitle,
      usdValue,
      usdValueUnit,
      handleImportSettlement,
      handleExportAccount,
      handleEditCustomReason,
      handleOtherReasonConfirm,
      handleOtherReasonCancel,
      handleEditField,
      handleEditFieldConfirm,
      handleEditFieldCancel,
      handleStatusChange,
      changePage,
      handleTableChange,
      handleBatchModify,
      handleBatchUpdateStatus,
      handleBatchUpdateExpected,
      handleBatchUpdateReceived,
      handleBatchModifyActualReceiptTime,
      selectedRowKeys,
      onSelectChange,
      isBatchOperation,
      handleWithholdingTaxChange,
      handleSaveBalance,
      tableHeight
    } = useSettlementTable(props, emit);
    const editFieldType = computed(() => {
      if (editingField.value === 'expectedReceiptTime' || editingField.value === 'actualReceiptTime') return 'date';
      if (editingField.value === 'actualReceivedAmount' || editingField.value === 'balance') return 'number';
      if (editingField.value === 'receivedStatus') return 'status';
      if (editingField.value === 'withholdingTax') return 'tax';
      return null;
    });
    const editFieldNumberPlaceholder = computed(() => editingField.value === 'balance' ? '请输入账号余额' : '请输入实际收款金额');
    const store = useStore();
    const routeName = computed(() => useRoute().name);
    const userInfo = computed(() => store.getParsedUserInfo);
    const checkPerm = permissionValue => {
      var _userInfo$value;
      const perms = ((_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.permissions) || [];
      return perms.some(item => {
        if (item === '*') return true;
        if (item === permissionValue) return true;
        const parts = item.split(':');
        return parts[0] === permissionValue && (parts[parts.length - 1] === '*' || parts[parts.length - 1] === 'update');
      });
    };
    const canEditBalance = computed(() => checkPerm('googleSettlement:gpfinance:update'));
    const canEditActualMoney = computed(() => checkPerm('googleSettlement:actmoney:update'));
    const canEditStatus = computed(() => checkPerm('googleSettlement:status:update'));
    const canEditReason = computed(() => checkPerm('googleSettlement:reason:update'));
    const canEditActualTime = computed(() => checkPerm('googleSettlement:acttime:update'));
    const canEditExpectedTime = computed(() => checkPerm('googleSettlement:expectedmoney:update'));
    const canEditPayment = computed(() => checkPerm('googleSettlement:payment:update'));
    const hasBatchPermission = computed(() => canEditBalance.value || canEditActualTime.value || canEditStatus.value || canEditReason.value || canEditPayment.value);
    const hasDirectEditPermission = canEditActualMoney;
    const getStatusColor = status => {
      var _statusMap$String;
      const color = (_statusMap$String = statusMap[String(status)]) === null || _statusMap$String === void 0 ? void 0 : _statusMap$String.color;
      if (color === 'default') return '#666';
      if (color === 'warning') return '#faad14';
      if (color === 'success') return '#52c41a';
      if (color === 'error') return '#ff4d4f';
      return color || '#666';
    };
    const hasReasonDetail = record => {
      var _record$receivedResEx, _record$receivedResEx2, _record$receivedResEx3;
      const list = ((_record$receivedResEx = record.receivedResExtInfo) === null || _record$receivedResEx === void 0 ? void 0 : _record$receivedResEx.receivedResList) || [];
      const imgs = ((_record$receivedResEx2 = record.receivedResExtInfo) === null || _record$receivedResEx2 === void 0 ? void 0 : _record$receivedResEx2.imageList) || [];
      const remark = (_record$receivedResEx3 = record.receivedResExtInfo) === null || _record$receivedResEx3 === void 0 ? void 0 : _record$receivedResEx3.supplementRemark;
      return list.length > 0 || imgs.length > 0 || !!remark;
    };
    const getReasonText = record => {
      var _record$receivedResEx4, _record$receivedResEx5;
      const list = ((_record$receivedResEx4 = record.receivedResExtInfo) === null || _record$receivedResEx4 === void 0 ? void 0 : _record$receivedResEx4.receivedResList) || [];
      const remark = (_record$receivedResEx5 = record.receivedResExtInfo) === null || _record$receivedResEx5 === void 0 ? void 0 : _record$receivedResEx5.supplementRemark;
      const reasons = list.map(item => item.receivedResMsg || reasonMap[item.receivedResCode]).filter(Boolean);
      return reasons[0] || remark || '-';
    };
    const handleSaveCell = async (key, value, originalRow) => {
      const supportedKeys = {
        balance: 'balance',
        actualReceivedAmount: 'actualReceivedAmount',
        actualReceiptTime: 'actualReceiptTime'
      };
      if (!supportedKeys[key]) return;
      try {
        const res = await updateAccountBill({
          id: originalRow.id,
          [key]: value !== null ? String(value) : undefined
        });
        if (res && res.code === OK) {
          message.success('更新成功');
          emit('update-list');
        }
      } catch {
        message.error('更新失败');
      }
    };
    let scrollTimer = null;
    const handleScroll = () => {
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
      scrollTimer = window.setTimeout(() => {
        const e = new Event('resize');
        window.dispatchEvent(e);
      }, 0);
    };
    onMounted(() => {
      // 监听父容器的滚动事件
      const parentElement = document.querySelector('.financial-settlement');
      if (parentElement) {
        parentElement.addEventListener('scroll', handleScroll);
      }
    });
    onBeforeUnmount(() => {
      // 移除事件监听
      const parentElement = document.querySelector('.financial-settlement');
      if (parentElement) {
        parentElement.removeEventListener('scroll', handleScroll);
      }
    });
    return (_ctx, _cache) => {
      var _props$pagination, _props$pagination2, _props$pagination3;
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_image_preview_group = _resolveComponent("a-image-preview-group");
      const _component_a_popover = _resolveComponent("a-popover");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_month_picker = _resolveComponent("a-month-picker");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(hasBatchPermission) ? (_openBlock(), _createBlock(_component_a_dropdown, {
        key: 0
      }, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
          default: _withCtx(() => [_unref(canEditBalance) ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "1",
            onClick: _unref(handleBatchModify)
          }, {
            default: _withCtx(() => [_createTextVNode("修改账号余额")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), _unref(canEditActualTime) ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "6",
            onClick: _unref(handleBatchModifyActualReceiptTime)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改实际收款时间 ")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), _unref(canEditStatus) ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "3",
            onClick: _unref(handleBatchUpdateStatus)
          }, {
            default: _withCtx(() => [_createTextVNode("修改收款状态")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), _unref(canEditReason) ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "4",
            onClick: _unref(handleBatchUpdateExpected)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改收款异常原因 ")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), _unref(canEditPayment) ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: "5",
            onClick: _unref(handleBatchUpdateReceived)
          }, {
            default: _withCtx(() => [_createTextVNode("更新收款信息")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_a_button, {
          style: {
            "margin-right": "8px"
          },
          disabled: !_unref(selectedRowKeys).length
        }, {
          default: _withCtx(() => [_createTextVNode(" 批量操作" + _toDisplayString(_unref(selectedRowKeys).length ? `(${_unref(selectedRowKeys).length})` : '') + " ", 1), _createVNode(_unref(DownOutlined))]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
        onClick: _unref(handleExportAccount)
      }, {
        default: _withCtx(() => [_createTextVNode("导出账单")]),
        _: 1
      }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_table, {
        size: "small",
        loading: __props.loading,
        columns: _unref(gpColumns),
        "data-source": __props.data,
        pagination: false,
        scroll: {
          x: 2000,
          y: _unref(tableHeight)
        },
        showSorterTooltip: false,
        "row-selection": {
          selectedRowKeys: _unref(selectedRowKeys),
          onChange: _unref(onSelectChange),
          getCheckboxProps: record => ({
            disabled: record.receivedStatus === 20
          })
        },
        "row-key": "id",
        onChange: _unref(handleTableChange),
        class: "custom-table"
      }, {
        headerCell: _withCtx(({
          column
        }) => {
          var _unref2;
          return [column.customTitle ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createTextVNode(_toDisplayString(column.title) + " ", 1), _createVNode(_component_a_tooltip, {
            title: column.tooltip
          }, {
            default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
              style: {
                "margin-left": "4px"
              }
            })]),
            _: 2
          }, 1032, ["title"])])) : _createCommentVNode("", true), column.key === 'expectedReceiptTime' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createTextVNode(_toDisplayString(column.title) + " ", 1), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "link",
            size: "small",
            class: "edit-button",
            onClick: $event => _unref(handleEditField)(column, 'expectedReceiptTime')
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditOutlined))]),
            _: 2
          }, 1032, ["onClick"])), [[_directive_permission, {
            permissionValue: 'googleSettlement:expectedmoney:update',
            permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
          }]])])) : _createCommentVNode("", true)];
        }),
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref$record$receive, _unref3;
          return [column.key === 'accountName' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(record.accountName || '-'), 1), _createVNode(_component_a_tooltip, {
            title: "外部结算"
          }, {
            default: _withCtx(() => [record.isNeedExternalSettlement === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "外")) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), column.key === 'bankInfo' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [record.receivingBank || record.bankCardFourDigits ? (_openBlock(), _createElementBlock("span", _hoisted_11, [_createTextVNode(_toDisplayString(record.receivingBank) + " ", 1), record.bankCardFourDigits ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(record.bankCardFourDigits) + ")", 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))], 64)) : _createCommentVNode("", true), column.key === 'balance' ? (_openBlock(), _createBlock(CellEditor, {
            key: 2,
            editable: _unref(canEditBalance),
            "row-key": "balance",
            row: record,
            onSave: handleSaveCell
          }, null, 8, ["editable", "row"])) : _createCommentVNode("", true), column.key === 'withholdingTax' ? (_openBlock(), _createBlock(CellEditor, {
            key: 3,
            "row-key": "withholdingTax",
            row: record
          }, null, 8, ["row"])) : _createCommentVNode("", true), column.key === 'actualInvoiceAmount' ? (_openBlock(), _createBlock(CellEditor, {
            key: 4,
            "row-key": "actualInvoiceAmount",
            row: record
          }, null, 8, ["row"])) : _createCommentVNode("", true), column.key === 'expectReceivedAmount' ? (_openBlock(), _createBlock(CellEditor, {
            key: 5,
            "row-key": "expectReceivedAmount",
            row: record
          }, null, 8, ["row"])) : _createCommentVNode("", true), column.key === 'actualReceivedAmount' ? (_openBlock(), _createBlock(CellEditor, {
            key: 6,
            editable: _unref(hasDirectEditPermission),
            "row-key": "actualReceivedAmount",
            row: record,
            onSave: handleSaveCell
          }, null, 8, ["editable", "row"])) : _createCommentVNode("", true), column.key === 'actualReceiptTime' ? (_openBlock(), _createBlock(CellEditor, {
            key: 7,
            editable: _unref(canEditActualTime),
            "row-key": "actualReceiptTime",
            row: record,
            onSave: handleSaveCell
          }, null, 8, ["editable", "row"])) : _createCommentVNode("", true), column.key === 'receivedStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", {
            class: "status-dot",
            style: _normalizeStyle({
              backgroundColor: getStatusColor(record.receivedStatus)
            })
          }, null, 4), _createElementVNode("span", {
            style: _normalizeStyle({
              color: getStatusColor(record.receivedStatus)
            })
          }, _toDisplayString((_unref$record$receive = _unref(statusMap)[record.receivedStatus]) === null || _unref$record$receive === void 0 ? void 0 : _unref$record$receive.text), 5), _withDirectives((_openBlock(), _createBlock(_component_a_select, {
            value: record.receivedStatus,
            "onUpdate:value": $event => record.receivedStatus = $event,
            style: {
              "width": "120px"
            },
            class: "edit-button",
            onChange: value => _unref(handleStatusChange)(value, record)
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select_option, {
              value: 0
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['0'].color === 'default' ? '#666' : _unref(statusMap)['0'].color
                })
              }, _toDisplayString(_unref(statusMap)['0'].text), 5)]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: 10
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['10'].color === 'warning' ? '#faad14' : _unref(statusMap)['10'].color
                })
              }, _toDisplayString(_unref(statusMap)['10'].text), 5)]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: 20
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['20'].color === 'success' ? '#52c41a' : _unref(statusMap)['20'].color
                })
              }, _toDisplayString(_unref(statusMap)['20'].text), 5)]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: 30
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['30'].color === 'error' ? '#ff4d4f' : _unref(statusMap)['30'].color
                })
              }, _toDisplayString(_unref(statusMap)['30'].text), 5)]),
              _: 1
            })]),
            _: 2
          }, 1032, ["value", "onUpdate:value", "onChange"])), [[_directive_permission, {
            permissionValue: 'googleSettlement:status:update',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]])])) : _createCommentVNode("", true), column.key === 'receivedResMsg' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [hasReasonDetail(record) ? (_openBlock(), _createBlock(_component_a_popover, {
            key: 0,
            trigger: "hover",
            placement: "left",
            "overlay-style": {
              width: '300px'
            }
          }, {
            content: _withCtx(() => {
              var _record$receivedResEx6, _record$receivedResEx7, _record$receivedResEx8, _record$receivedResEx9, _record$receivedResEx10;
              return [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_unref(WarningOutlined), {
                class: "icon-header"
              }), _createTextVNode(" 异常说明详情 ")]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_record$receivedResEx6 = record.receivedResExtInfo) === null || _record$receivedResEx6 === void 0 ? void 0 : _record$receivedResEx6.receivedResList, (item, i) => {
                return _openBlock(), _createElementBlock("div", {
                  class: "reason-list",
                  key: i
                }, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString(item.receivedResMsg || _unref(reasonMap)[item.receivedResCode]), 1)]);
              }), 128)), (_record$receivedResEx7 = record.receivedResExtInfo) !== null && _record$receivedResEx7 !== void 0 && _record$receivedResEx7.supplementRemark ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_hoisted_21, _createTextVNode(" " + _toDisplayString(record.receivedResExtInfo.supplementRemark), 1)])) : _createCommentVNode("", true), (_record$receivedResEx8 = record.receivedResExtInfo) !== null && _record$receivedResEx8 !== void 0 && (_record$receivedResEx8 = _record$receivedResEx8.imageList) !== null && _record$receivedResEx8 !== void 0 && _record$receivedResEx8.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_unref(PaperClipOutlined)), _createTextVNode(" " + _toDisplayString(`附件凭证(${(_record$receivedResEx9 = record.receivedResExtInfo) === null || _record$receivedResEx9 === void 0 || (_record$receivedResEx9 = _record$receivedResEx9.imageList) === null || _record$receivedResEx9 === void 0 ? void 0 : _record$receivedResEx9.length})`), 1)])) : _createCommentVNode("", true), (_record$receivedResEx10 = record.receivedResExtInfo) !== null && _record$receivedResEx10 !== void 0 && (_record$receivedResEx10 = _record$receivedResEx10.imageList) !== null && _record$receivedResEx10 !== void 0 && _record$receivedResEx10.length ? (_openBlock(), _createBlock(_component_a_image_preview_group, {
                key: 2
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.receivedResExtInfo.imageList, (img, idx) => {
                  return _openBlock(), _createBlock(_component_a_image, {
                    key: idx,
                    src: img,
                    width: 60,
                    height: 60,
                    style: {
                      "object-fit": "cover",
                      "border-radius": "4px",
                      "cursor": "pointer"
                    }
                  }, null, 8, ["src"]);
                }), 128))])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)])];
            }),
            default: _withCtx(() => {
              var _record$receivedResEx11;
              return [_createElementVNode("span", {
                class: "reason-summary-text",
                onClick: $event => _unref(canEditReason) && _unref(handleEditCustomReason)(record),
                style: _normalizeStyle({
                  cursor: _unref(canEditReason) ? 'pointer' : 'default'
                })
              }, [_createTextVNode(_toDisplayString(getReasonText(record)) + " ", 1), (_record$receivedResEx11 = record.receivedResExtInfo) !== null && _record$receivedResEx11 !== void 0 && (_record$receivedResEx11 = _record$receivedResEx11.imageList) !== null && _record$receivedResEx11 !== void 0 && _record$receivedResEx11.length ? (_openBlock(), _createElementBlock("span", _hoisted_25, [_createVNode(_unref(PaperClipOutlined)), _createTextVNode(" " + _toDisplayString(record.receivedResExtInfo.imageList.length), 1)])) : _createCommentVNode("", true)], 12, _hoisted_24)];
            }),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "reason-empty",
            onClick: $event => _unref(canEditReason) && _unref(handleEditCustomReason)(record),
            style: _normalizeStyle({
              cursor: _unref(canEditReason) ? 'pointer' : 'default'
            })
          }, " - ", 12, _hoisted_26))])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["loading", "columns", "data-source", "scroll", "row-selection", "onChange"])]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_a_pagination, {
        total: (_props$pagination = __props.pagination) === null || _props$pagination === void 0 ? void 0 : _props$pagination.total,
        onChange: _unref(changePage),
        current: (_props$pagination2 = __props.pagination) === null || _props$pagination2 === void 0 ? void 0 : _props$pagination2.current,
        pageSize: (_props$pagination3 = __props.pagination) === null || _props$pagination3 === void 0 ? void 0 : _props$pagination3.pageSize,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["total", "onChange", "current", "pageSize", "show-total"])]), _createVNode(OtherReasonModal, {
        "model-visible": _unref(otherReasonModalVisible),
        "onUpdate:model-visible": _cache[0] || (_cache[0] = $event => _isRef(otherReasonModalVisible) ? otherReasonModalVisible.value = $event : null),
        "current-record": _unref(currentRecord),
        "reason-map": _unref(reasonMap),
        onConfirm: _unref(handleOtherReasonConfirm),
        onCancel: _unref(handleOtherReasonCancel)
      }, null, 8, ["model-visible", "current-record", "reason-map", "onConfirm", "onCancel"]), _createVNode(_component_a_modal, {
        open: _unref(editFieldModalVisible),
        "onUpdate:open": _cache[8] || (_cache[8] = $event => _isRef(editFieldModalVisible) ? editFieldModalVisible.value = $event : null),
        title: _unref(editFieldTitle),
        onOk: _unref(handleEditFieldConfirm),
        onCancel: _unref(handleEditFieldCancel),
        centered: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          layout: "vertical"
        }, {
          default: _withCtx(() => [_unref(editingField) !== 'expectedReceiptTime' ? (_openBlock(), _createBlock(_component_a_alert, {
            key: 0,
            type: "info",
            style: {
              "margin": "12px 0"
            },
            message: `已选择${_unref(selectedRowKeys).length}条记录，此操作将批量修改所有选中记录，请谨慎操作`
          }, null, 8, ["message"])) : _createCommentVNode("", true), _unref(editingField) === 'expectedReceiptTime' ? (_openBlock(), _createBlock(_component_a_alert, {
            key: 1,
            banner: "",
            style: {
              "margin": "16px 0"
            },
            message: "此操作将更新指定结算月份下所有账号的预计收款时间，跨页有效，不会影响其他月份的数据"
          })) : _createCommentVNode("", true), _unref(editingField) === 'expectedReceiptTime' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_a_month_picker, {
              value: _unref(editingMonth),
              "onUpdate:value": _cache[1] || (_cache[1] = $event => _isRef(editingMonth) ? editingMonth.value = $event : null),
              style: {
                "width": "100%"
              },
              format: "YYYY-MM",
              placeholder: "请选择要更新的月份"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_a_date_picker, {
              value: _unref(editingValue),
              "onUpdate:value": _cache[2] || (_cache[2] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              },
              format: "YYYY-MM-DD"
            }, null, 8, ["value"])]),
            _: 1
          })], 64)) : (_openBlock(), _createBlock(_component_a_form_item, {
            key: 3,
            label: _unref(editFieldTitle)
          }, {
            default: _withCtx(() => [_unref(editFieldType) === 'date' ? (_openBlock(), _createBlock(_component_a_date_picker, {
              key: 0,
              value: _unref(editingValue),
              "onUpdate:value": _cache[3] || (_cache[3] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              },
              format: "YYYY-MM-DD"
            }, null, 8, ["value"])) : _unref(editFieldType) === 'number' ? (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: _unref(editingValue),
              "onUpdate:value": _cache[4] || (_cache[4] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              },
              precision: 2,
              min: 0,
              max: 100000000,
              placeholder: _unref(editFieldNumberPlaceholder)
            }, null, 8, ["value", "placeholder"])) : _unref(editFieldType) === 'status' ? (_openBlock(), _createBlock(_component_a_select, {
              key: 2,
              value: _unref(editingValue),
              "onUpdate:value": _cache[5] || (_cache[5] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select_option, {
                value: 0
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['0'].color === 'default' ? '#666' : _unref(statusMap)['0'].color
                  })
                }, _toDisplayString(_unref(statusMap)['0'].text), 5)]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: 10
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['10'].color === 'warning' ? '#faad14' : _unref(statusMap)['10'].color
                  })
                }, _toDisplayString(_unref(statusMap)['10'].text), 5)]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: 20
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['20'].color === 'success' ? '#52c41a' : _unref(statusMap)['20'].color
                  })
                }, _toDisplayString(_unref(statusMap)['20'].text), 5)]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: 30
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['30'].color === 'error' ? '#ff4d4f' : _unref(statusMap)['30'].color
                  })
                }, _toDisplayString(_unref(statusMap)['30'].text), 5)]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])) : _unref(editFieldType) === 'tax' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_a_input_number, {
              value: _unref(usdValue),
              "onUpdate:value": _cache[6] || (_cache[6] = $event => _isRef(usdValue) ? usdValue.value = $event : null),
              "addon-after": "BRL",
              placeholder: "请输入预扣税",
              precision: 2,
              min: 0,
              max: 100000000,
              style: {
                "width": "190px"
              },
              onChange: _unref(handleWithholdingTaxChange)
            }, null, 8, ["value", "onChange"]), _createVNode(_unref(ArrowRightOutlined), {
              style: {
                "margin": "0 8px"
              }
            }), _createVNode(_component_a_input_number, {
              value: _unref(editingValue),
              "onUpdate:value": _cache[7] || (_cache[7] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              placeholder: "转换汇率后预扣税",
              precision: 2,
              min: 0,
              max: 100000000,
              "addon-after": _unref(usdValueUnit),
              style: {
                "width": "190px"
              }
            }, null, 8, ["value", "addon-after"])])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["label"]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "title", "onOk", "onCancel"]), _createVNode(IOSBillModal, {
        "model-visible": _unref(modalVisible),
        "onUpdate:model-visible": _cache[9] || (_cache[9] = $event => _isRef(modalVisible) ? modalVisible.value = $event : null),
        allAccountList: __props.allAccountList
      }, null, 8, ["model-visible", "allAccountList"])]);
    };
  }
});